import {
  HOME,
  BOOK_NOW_LINK,
  PROPERTY_NAME,
  separatorColoredUp,
  separatorColoredDown,
} from '../../utils/constants';
import heroImage from '../../assets/imgs/hero.webp';
import { useEffect } from 'react';
import { CapitalizeFirstLetter } from '../../utils/capitalizeFirstLetter';
import About from './about/About';
import Gallery from './gallery/Gallery';
import Restaurant from './restaurant/Restaurant';
import Services from './services/Services';
import Accommodations from './accommodations/Accommodations';
import Variables from '../../style/variables.scss';

const gallery = require.context('../../assets/imgs/gallery', true);
const galleryList = gallery?.keys().map((image: any) => gallery(image));

const Home = () => {
  let header: HTMLElement | null = document.getElementById('nav_container');

  useEffect(() => {
    document.title = `${CapitalizeFirstLetter(PROPERTY_NAME)}`;
    document.body.classList.remove('lock_scroll');
  }, []);

  setTimeout(() => {
    if (header !== null) {
      header.style.top = '0';
    }
  }, 1200);

  return (
    <div id={HOME} className='home'>
      <div className='home_container_hero'>
        <img src={heroImage} alt='hero' />
        <div className='home_container_hero_overlay'></div>
        <a
          href={BOOK_NOW_LINK}
          target='_blank'
          rel='noreferrer'
          className='home_container_hero_overlay_button button_dark'
        >
          <div className='opacity_transition_low'>BOOK NOW</div>
        </a>
      </div>
      <h1 hidden>{PROPERTY_NAME}</h1>
      <About />
      {separatorColoredUp(Variables.aux)}
      <Services />
      <Accommodations />
      <Restaurant />
      {separatorColoredDown(Variables.complementaryColor)}
      <Gallery imageList={galleryList} />
    </div>
  );
};

export default Home;
